// Admin auth store — no longer persists tokens in localStorage (XSS-resistant).
// The backend sets a httpOnly SameSite=None Secure cookie on /admin/login;
// the browser sends it automatically with withCredentials.
// This module only tracks the admin's identifying email (non-sensitive) in sessionStorage
// for UI display, and probes /admin/me to verify session validity.
import api from './api';

const EMAIL_KEY = 'dt_admin_email';

export function getAdminEmail() {
    try { return sessionStorage.getItem(EMAIL_KEY) || ''; } catch (_) { return ''; }
}
export function setAdminEmail(email) {
    try { sessionStorage.setItem(EMAIL_KEY, email || ''); } catch (_) { /* ignore */ }
}
export function clearAdminEmail() {
    try { sessionStorage.removeItem(EMAIL_KEY); } catch (_) { /* ignore */ }
}

export async function verifyAdminSession() {
    try {
        const r = await api.get('/admin/me');
        return { ok: true, email: r.data?.email || '' };
    } catch (err) {
        return { ok: false, error: err };
    }
}

export async function adminLogout() {
    try { await api.post('/admin/logout'); } catch (_) { /* ignore */ }
    clearAdminEmail();
}
